// Simple default configuration for application, when none is provided

module.exports = (
{
	"Product": "Unnamed_Service",
	"ProductVersion": "0.0.1",

	"ServicePort": 8080
});

